/**
 * Payments-domain color pairs (DNKADM-0269) that don't map onto an existing
 * `AdminTokens` value: `ChangeProviderDialog`'s selected-provider tile tint (a
 * green distinct from the court-green brand, kept as the pre-0269 literal). LIGHT
 * values are byte-identical to the pre-0269 literals (the 0266 identity
 * constraint); DARK follows the established translucent-tint ramp (the same
 * success-ink family as `STATUS_DARK.active` in `../tokens.ts`).
 *
 * Consumer pattern: `const pm = resolvePaymentsMaps(useTheme())`.
 */
import type { Theme } from '@mui/material/styles';

export interface PaymentsMaps {
  /** `ChangeProviderDialog`'s selected-provider tile background / hover background. */
  providerSelected: { bg: string; hoverBg: string };
}

const LIGHT: PaymentsMaps = {
  providerSelected: { bg: 'rgba(46, 125, 50, 0.06)', hoverBg: 'rgba(46, 125, 50, 0.08)' },
};

const DARK: PaymentsMaps = {
  providerSelected: { bg: 'rgba(127,211,163,0.14)', hoverBg: 'rgba(127,211,163,0.2)' },
};

/** Per-mode payments-domain pairs. Light === the pre-0269 literals. */
function buildPaymentsMaps(mode: 'light' | 'dark'): PaymentsMaps {
  return mode === 'dark' ? DARK : LIGHT;
}

/** Resolve the payments-domain pairs off the mounted theme. */
export function resolvePaymentsMaps(theme: Theme): PaymentsMaps {
  return buildPaymentsMaps(theme.palette.mode === 'dark' ? 'dark' : 'light');
}
